import api from 'factory/AxiosInstance'
import { MicrosoftGraphRequest } from 'models/request/Index';
import { MicrosoftGraphResponse } from 'models/response/Index';

const URL = 'https://graph.microsoft.com/v1.0/me/getMemberGroups'

export const callMsMember = async (authorization: string) : Promise<MicrosoftGraphResponse> => {
  const request = new MicrosoftGraphRequest();
  const { data } = await api.post(URL, request, {
    headers:
    {
      'Authorization': authorization
    }
  });
  return data;
}